import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import Promocion from './components/Promocion';
import Formulario from './components/Formulario';
import Terminos from './components/Terminos';
import './App.css';

// Componente wrapper para pasar navigate a los componentes
function AppContent() {
  const navigate = useNavigate();
  const location = useLocation();
  const [userData, setUserData] = useState(null); // Datos del usuario autenticado

  const handleContinue = (authData = null) => {
    // Si hay datos de autenticación, guardarlos en sessionStorage
    // para que estén disponibles cuando se navegue a /form
    if (authData) {
      setUserData(authData);
      sessionStorage.setItem('userAuthData', JSON.stringify(authData));
    }
    navigate('/form');
  };

  const handleShowTerminos = () => {
    navigate('/terminos');
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="App">
      {/* Mensaje para pantallas grandes */}
      <div className="desktop-message">
        <div className="desktop-message-content">
          <h1>📱 Solo disponible para móviles</h1>
          <p>Esta aplicación está diseñada para ser utilizada en dispositivos móviles.</p>
          <p>Por favor, accede desde tu teléfono o tablet.</p>
        </div>
      </div>

      {/* Contenido de la aplicación (oculto en desktop) */}
      <div className="mobile-content">
        <Routes>
          <Route
            path="/form"
            element={<Formulario userData={userData} />}
          />
          <Route
            path="/terminos"
            element={<Terminos onBack={handleBack} />}
          />
          <Route
            path="/:cadena"
            element={<Promocion onShowTerminos={handleShowTerminos} />}
          />
          <Route
            path="/"
            element={<Promocion onShowTerminos={handleShowTerminos} />}
          />
        </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
